import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const api = buildService('/companies/{id}/company_menus', {
  only: ['all']
});
const companyMenuService = {
  useFetchAll: (companyId, fetchImmediately, setLoading) => {
    const [companyMenu, setCompanyMenu, fetchCompanyMenu] = serviceMethods.useFetch({
      callback: useCallback(async queryParams => await api.all(companyId, queryParams), [companyId]),
      setLoading,
      fetchImmediately
    });
    return [companyMenu, fetchCompanyMenu];
  }
};
companyMenuService.useCrud = (companyId, fetchImmediately, setLoading) => {
  const [companyMenu, fetchCompanyMenu] = companyMenuService.useFetchAll(companyId, fetchImmediately, setLoading);
  return {
    companyMenu,
    fetchCompanyMenu
  };
};
export default companyMenuService;